import { useState } from 'react'
import { useAuth } from '../store/auth'

/** Bluesky-only sign-in — bank scores on the board. No Google. */
export function AuthModal({ open, onClose }: { open: boolean; onClose: () => void }) {
  const loginBluesky = useAuth((s) => s.loginBluesky)
  const [identifier, setIdentifier] = useState('')
  const [password, setPassword] = useState('')
  const [busy, setBusy] = useState(false)
  const [err, setErr] = useState<string | null>(null)

  if (!open) return null

  async function submit(e: React.FormEvent) {
    e.preventDefault()
    setBusy(true)
    setErr(null)
    try {
      await loginBluesky('https://bsky.social', identifier.trim(), password)
      onClose()
    } catch (e) {
      setErr(e instanceof Error ? e.message : 'login failed')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="fixed inset-0 z-50 grid place-items-center bg-black/80 p-4 backdrop-blur-sm" onClick={onClose}>
      <div className="cyber-panel cyber-pink w-full max-w-sm p-6" onClick={(e) => e.stopPropagation()}>
        <h2 className="goon-title mb-1 text-3xl">Connect Bluesky</h2>
        <p className="mb-4 text-sm text-muted">Bank sessions. Climb the board. Pull feed through your account.</p>

        <form onSubmit={submit} className="space-y-2">
          <input
            className="input"
            placeholder="handle.bsky.social"
            autoCapitalize="none"
            autoCorrect="off"
            value={identifier}
            onChange={(e) => setIdentifier(e.target.value)}
          />
          <input
            className="input"
            placeholder="app password (xxxx-xxxx-xxxx-xxxx)"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          {err ? <div className="text-sm font-bold text-pow neon-pink">{err}</div> : null}
          <button
            type="submit"
            disabled={busy || !identifier || !password}
            className="btn-goon w-full disabled:opacity-40"
          >
            {busy ? '…' : 'Connect & Play'}
          </button>
        </form>

        <p className="mt-3 text-center text-[11px] text-muted">
          Use a Bluesky <b className="text-[#e7e7f2]">app password</b> — not your main password.
        </p>
      </div>
    </div>
  )
}